import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { getSettings, saveSettings } from "../adminApi";

const GROUPS = [
  { title: "Contact Information", fields: [
    { k: "phone", label: "Phone" }, { k: "email", label: "Email" }, { k: "website", label: "Website" }, { k: "whatsapp", label: "WhatsApp Number" },
  ]},
  { title: "Address", fields: [{ k: "address", label: "Full Address", area: true }] },
  { title: "Social Links", fields: [
    { k: "linkedin", label: "LinkedIn" }, { k: "instagram", label: "Instagram" }, { k: "youtube", label: "YouTube" }, { k: "facebook", label: "Facebook" }, { k: "twitter", label: "X / Twitter" },
  ]},
  { title: "Homepage Content", fields: [{ k: "homeHeadline", label: "Homepage Headline" }] },
];

export default function Content() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { getSettings().then(setSettings).catch(() => toast.error("Failed to load settings.")); }, []);

  const set = (k) => (e) => setSettings((s) => ({ ...s, [k]: e.target.value }));
  const save = async () => {
    setSaving(true);
    try { await saveSettings(settings); toast.success("Settings saved."); }
    catch { toast.error("Save failed."); }
    finally { setSaving(false); }
  };

  if (!settings) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-orange" /></div>;

  return (
    <div data-testid="admin-content" className="max-w-3xl">
      <h1 className="mb-1 text-2xl font-bold text-slate-900">Content & Settings</h1>
      <p className="mb-6 text-sm text-slate-500">Edit site-wide contact details, address, social links and homepage content.</p>

      <div className="space-y-6">
        {GROUPS.map((g) => (
          <div key={g.title} className="rounded-xl border border-slate-200 bg-white p-5">
            <h2 className="mb-4 font-semibold text-slate-800">{g.title}</h2>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {g.fields.map((f) => (
                <label key={f.k} className={`flex flex-col gap-1.5 text-sm text-slate-600 ${f.area ? "sm:col-span-2" : ""}`}>
                  {f.label}
                  {f.area ? (
                    <textarea value={settings[f.k] || ""} onChange={set(f.k)} rows={3} data-testid={`setting-${f.k}`} className="rounded-lg border border-slate-300 px-3 py-2 outline-none focus:border-orange" />
                  ) : (
                    <input value={settings[f.k] || ""} onChange={set(f.k)} data-testid={`setting-${f.k}`} className="rounded-lg border border-slate-300 px-3 py-2 outline-none focus:border-orange" />
                  )}
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>

      <button onClick={save} disabled={saving} data-testid="content-save" className="mt-6 inline-flex items-center gap-2 rounded-lg bg-orange px-6 py-2.5 font-medium text-white hover:opacity-90 disabled:opacity-60">
        {saving ? <><Loader2 className="h-4 w-4 animate-spin" /> Saving…</> : "Save changes"}
      </button>
    </div>
  );
}
